import Echo from 'laravel-echo';

import Pusher from 'pusher-js';

/**
 * Fluent no-op channel so pages can call Echo without a running Reverb server.
 *
 * @returns {object}
 */
function createDisconnectedChannel() {
    const chain = {
        listen() {
            return chain;
        },
        listenForWhisper() {
            return chain;
        },
        whisper() {
            return chain;
        },
        here() {
            return chain;
        },
        joining() {
            return chain;
        },
        leaving() {
            return chain;
        },
        error() {
            return chain;
        },
        leave() {
            return chain;
        },
    };

    return chain;
}

const reverbKey = import.meta.env.VITE_REVERB_APP_KEY;

if (reverbKey) {
    window.Pusher = Pusher;

    window.Echo = new Echo({
        broadcaster: 'reverb',
        key: reverbKey,
        wsHost: import.meta.env.VITE_REVERB_HOST,
        wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
        wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
        forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
        enabledTransports: ['ws', 'wss'],
    });
} else {
    window.Echo = {
        private() {
            return createDisconnectedChannel();
        },
        join() {
            return createDisconnectedChannel();
        },
        leave() {},
        registerAxiosRequestInterceptor() {},
    };
}
